import { useTranslation } from "react-i18next";
import { Button } from "components/button";
import { Input } from "components/ui/input";
import { Text } from "components/text";
import { MAX_FREE_TEXT_LENGTH } from "./useKeywordFeedbackPopoverState";

interface KeywordFeedbackFreeTextFormProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => Promise<void>;
  onBack: () => void;
}

export const KeywordFeedbackFreeTextForm = ({
  value,
  onChange,
  onSubmit,
  onBack,
}: KeywordFeedbackFreeTextFormProps) => {
  const { t } = useTranslation(["components"]);

  return (
    <div className="px-4 py-3 flex flex-col gap-2">
      <div className="flex gap-1.5">
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t(
            "components:keywordsTab.keywordFeedbackPopover.otherPlaceholder",
          )}
          className="h-8 text-xs rounded-lg flex-1"
          maxLength={MAX_FREE_TEXT_LENGTH}
          autoFocus
          onKeyDown={(e) => {
            if (e.key === "Enter") onSubmit();
          }}
          data-testid="feedback-free-text"
        />
        <Button
          size="small"
          type="button"
          onClick={onSubmit}
          className="h-auto px-3 py-1.5 text-xs font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700 shrink-0"
          data-testid="feedback-submit-other"
        >
          {t("components:keywordsTab.keywordFeedbackPopover.submit")}
        </Button>
      </div>
      <div className="flex items-center justify-between">
        <Button
          variant="link"
          size="small"
          type="button"
          onClick={onBack}
          className="h-auto p-0 text-xs font-normal text-secondary-400 hover:text-secondary-600 hover:no-underline"
        >
          {t("components:keywordsTab.keywordFeedbackPopover.back")}
        </Button>
        <Text as="span" variant="caption">
          {value.length}/{MAX_FREE_TEXT_LENGTH}
        </Text>
      </div>
    </div>
  );
};
